// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__1rcX6","sub_container":"WordGameLayout_sub_container__3Bvpj"};